import Header from "@/components/Header";
import { AuthForm } from "@/components/auth/AuthForm";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Container } from "@/components/design-system/Container";
import { Heading } from "@/components/design-system/Heading";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const handleForgotPassword = () => {
    navigate("/forgot-password", { state: { email } });
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Container size="sm" className="pt-20 px-4">
        <Heading level="h1" className="mb-8">Sign In</Heading>
        <div className="max-w-lg mx-auto">
          <AuthForm mode="login" onEmailChange={setEmail} />
          <div className="text-center mt-6">
            <p className="text-sm text-muted-foreground">
              Don't have an account?{" "}
              <Button
                variant="link"
                className="p-0 h-auto"
                onClick={() => navigate("/register")}
              >
                Register
              </Button>
            </p>
            <Button
              variant="link"
              className="mt-2"
              onClick={handleForgotPassword}
            >
              Forgot Password?
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Login;